module.exports = __webpack_public_path__ + "fonts/Onest-VariableFont_wght.3e0047e3.ttf";